/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { MarkerInfo, LatLng, IMapContextMenuData, IMapContextMenuPermissions } from '../../../core/models';

@Component({
  selector: 'fm-map-menu-container',
  templateUrl: './map-menu-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapMenuContainerComponent {
  @Input()
  public menuData: IMapContextMenuData<MarkerInfo>;
  @Input()
  public set userPermissions(value: IMapContextMenuPermissions) {
    this._userPermissions = value;
    this.showManagePostedSpeedSeparator = this._userPermissions.directions;
    this.showDriverDispatchSeparator = this._userPermissions.directions;
    this.showCreateGeofenceSeparator =
      this.showDriverDispatchSeparator || this._userPermissions.sendToGarmin || this._userPermissions.driverDispatch;
    this.showFindNearestSeparator =
      this.showCreateGeofenceSeparator ||
      this._userPermissions.zoomTo ||
      this._userPermissions.streetView ||
      this._userPermissions.createGeofence;
  }
  public get userPermissions(): IMapContextMenuPermissions {
    return this._userPermissions;
  }

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();
  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public driverDispatchClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public createGeofenceClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public locationToGarminClicked: EventEmitter<LatLng> = new EventEmitter();
  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();
  @Output()
  public copyCoordinatesClicked: EventEmitter<string> = new EventEmitter();
  @Output()
  public managePostedSpeedClicked: EventEmitter<void> = new EventEmitter();

  public showFindNearestSeparator: boolean;
  public showCreateGeofenceSeparator: boolean;
  public showDriverDispatchSeparator: boolean;
  public showManagePostedSpeedSeparator: boolean;

  private _userPermissions: IMapContextMenuPermissions;

  public onMenuClosed(): void {
    this.closed.emit();
  }

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
    this.closed.emit();
  }

  public onDriverDispatchClicked(): void {
    this.driverDispatchClicked.emit();
    this.closed.emit();
  }

  public onCreateGeofenceClicked(): void {
    this.createGeofenceClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
    this.closed.emit();
  }

  public onLocationToGarminClicked(): void {
    this.locationToGarminClicked.emit(this.menuData.clickLatLng);
    this.closed.emit();
  }

  public onStreetViewClicked(): void {
    if (this.menuData.streetViewAvailable) {
      this.streetViewClicked.emit();
      this.closed.emit();
    }
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
    this.closed.emit();
  }

  public onCopyCoordinates(coordinatesToCopy: string): void {
    this.copyCoordinatesClicked.emit(coordinatesToCopy);
  }

  public onManagePostedSpeedClicked(): void {
    this.managePostedSpeedClicked.emit();
    this.closed.emit();
  }
}
